// extracted by mini-css-extract-plugin
module.exports = {"getAuthCode":"R6paY17jsdjIInYgbhot-w=="};